module.exports = __webpack_public_path__ + "media/images/lb/662-73b21d12ff2374705a541620bc802bc9.svg";